module.exports = __webpack_public_path__ + "img/vanguards_3.3023fee.jpg";